import { useEffect, useRef, useState } from "react";

// Reveals once when the observed element first enters the viewport, then stays revealed.
function useRevealOnScroll({ threshold = 0.15, rootMargin = "0px 0px -10% 0px" } = {}) {
    const ref = useRef(null);
    const [revealed, setRevealed] = useState(typeof IntersectionObserver === "undefined");

    useEffect(() => {
        if (revealed) return;
        const node = ref.current;
        if (!node) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setRevealed(true);
                    observer.disconnect();
                }
            },
            { threshold, rootMargin }
        );

        observer.observe(node);
        return () => observer.disconnect();
    }, [revealed, threshold, rootMargin]);

    return [ref, revealed];
}

export default useRevealOnScroll;
